export default __webpack_public_path__ + "static/media/38.dd9f9631.png";